import styled from 'styled-components'

export const Styled = {
  Wrapper: styled.div`
    background-color: ${({ theme }) => theme.colors.white[6]};
    border-radius: 0.6rem;
    color: var(--c-theme-inverted);
    padding: 0.5rem 0.5rem 0.5rem 1rem;
  `,
  Key: styled.div`
    flex: 1 1 auto;
    font-size: 0.9rem;
    line-height: 1;
  `,
  KeyWrapper: styled.div`
    align-items: center;
    display: flex;
    gap: 0.5rem;
  `,
}
